
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as gate0rYZ8vPH1qgDA_45ZeP0gSbc2_45PnyuPwuCcblhonTRQx0Meta } from "/app/pages/gate.vue?macro=true";
import { default as initG2FX0UCllKsrkGzgcLbR9jl_450J6kvs4ij__45uJRfunYkMeta } from "/app/pages/init.vue?macro=true";
import { default as joinG6hJzd4qDNqMrWK1V0hOmrgSXueSQHqN__vOusqasQEMeta } from "/app/pages/join.vue?macro=true";
import { default as _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta } from "/app/pages/news/[id].vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta } from "/app/pages/news.vue?macro=true";
import { default as _91type_93QO15Mqi334KgG8myVtby0kSOoX5XbkxNL4nKBTyaQgcMeta } from "/app/pages/legal/[type].vue?macro=true";
import { default as legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta } from "/app/pages/legal.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta } from "/app/pages/terms.vue?macro=true";
import { default as _91id_9382KIwZ8q0OETkLNvcWcyEmEGEADky7LccPZr2Hn_E6cMeta } from "/app/pages/notice/[id].vue?macro=true";
import { default as index8FC4I14Q6HOdNgY_7MJ_lQbxFvX4D_45XA1oJcOGwRD48Meta } from "/app/pages/notice/index.vue?macro=true";
import { default as noticeMikbeDwzJDB0arjP_ptdRwGjLQ3KbX4SdMjgfsSsIIUMeta } from "/app/pages/notice.vue?macro=true";
import { default as download6h9owwVnkqAZ2H8OXbfkmrYtCXhaB_4bQT_45sQ5sPu2sMeta } from "/app/pages/download.vue?macro=true";
import { default as nicknameRbz_tKLZUCOffqmOAA81CGroho7pmuMgB6c0gMBne0oMeta } from "/app/pages/nickname.vue?macro=true";
import { default as emailh4x2lprn_k_45v3qsGRuqSyCTFWQWUYJOUTskaSlXf8DUMeta } from "/app/pages/settings/email.vue?macro=true";
import { default as indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as indexRHXcIp9ecSXLe2l_vTDRyyK9V6LHYGUSeEbP_DhKrFAMeta } from "/app/pages/settings/contact/index.vue?macro=true";
import { default as write1hsMD4Q3_1bbR_EccBE4m8_HDVnwA_xFkhXF_45E8XEmUMeta } from "/app/pages/settings/contact/write.vue?macro=true";
import { default as detail2tntkz31j9m7I9TNts2W_hzhFaP1FF7nvOQBQilxcqEMeta } from "/app/pages/settings/contact/detail.vue?macro=true";
import { default as contactOVmD7bBKr0Jfiwkf1udIRL_PMnpc6b7Oi1uPKkarWk0Meta } from "/app/pages/settings/contact.vue?macro=true";
import { default as nicknameMVNfXDTU9WkJC4zViqxwQb6CuXDZB8QvWA_wIidcQtsMeta } from "/app/pages/settings/nickname.vue?macro=true";
import { default as passwordNVWE3EfleOq6pk0GfC9PP9zdqd_45L25z7QS8QgKB7ToYMeta } from "/app/pages/settings/password.vue?macro=true";
import { default as delete_45accountko_nyf8k9H_45zrlMEl_45O5f_458An_458fK_45Iv3BndW8zhqOsMeta } from "/app/pages/settings/delete-account.vue?macro=true";
import { default as settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta } from "/app/pages/settings.vue?macro=true";
import { default as textbookSbwXsTtI6w70b7asKiFzHZTesDPELtDTVRFdMmzaaLYMeta } from "/app/pages/textbook.vue?macro=true";
import { default as introducebIA8YYR27T9dpby_7omWcyq_45n915FvkiXS8NuE4lb1IMeta } from "/app/pages/introduce.vue?macro=true";
import { default as maintenanceT_45jg7_pWb39JSa1hwfoRit1d5KL66Qjib5lqwfdmyV8Meta } from "/app/pages/maintenance.vue?macro=true";
import { default as litefEUBSsYGM_45B3JK8Blumr0mx8_45HeGaNLD1OTaqPcn2ikMeta } from "/app/pages/web-play/lite.vue?macro=true";
import { default as indexpQoNuxtsxBLDWwAR4tiJpvJp9EwPQkiGtEK5lm4sIloMeta } from "/app/pages/web-play/index.vue?macro=true";
import { default as education_45resourcesQ0Q3AEC7CJ_45ZAzKFMxjffmy39nZdxOD1Nq6aGgFoqZEMeta } from "/app/pages/education-resources.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "faq___ko",
    path: "/ko/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ja",
    path: "/ja/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "gate___ko",
    path: "/ko/gate",
    meta: gate0rYZ8vPH1qgDA_45ZeP0gSbc2_45PnyuPwuCcblhonTRQx0Meta || {},
    component: () => import("/app/pages/gate.vue")
  },
  {
    name: "gate___ja",
    path: "/ja/gate",
    meta: gate0rYZ8vPH1qgDA_45ZeP0gSbc2_45PnyuPwuCcblhonTRQx0Meta || {},
    component: () => import("/app/pages/gate.vue")
  },
  {
    name: "gate___en",
    path: "/en/gate",
    meta: gate0rYZ8vPH1qgDA_45ZeP0gSbc2_45PnyuPwuCcblhonTRQx0Meta || {},
    component: () => import("/app/pages/gate.vue")
  },
  {
    name: "init___ko",
    path: "/ko/init",
    meta: initG2FX0UCllKsrkGzgcLbR9jl_450J6kvs4ij__45uJRfunYkMeta || {},
    component: () => import("/app/pages/init.vue")
  },
  {
    name: "init___ja",
    path: "/ja/init",
    meta: initG2FX0UCllKsrkGzgcLbR9jl_450J6kvs4ij__45uJRfunYkMeta || {},
    component: () => import("/app/pages/init.vue")
  },
  {
    name: "init___en",
    path: "/en/init",
    meta: initG2FX0UCllKsrkGzgcLbR9jl_450J6kvs4ij__45uJRfunYkMeta || {},
    component: () => import("/app/pages/init.vue")
  },
  {
    name: "join___ko",
    path: "/ko/join",
    meta: joinG6hJzd4qDNqMrWK1V0hOmrgSXueSQHqN__vOusqasQEMeta || {},
    component: () => import("/app/pages/join.vue")
  },
  {
    name: "join___ja",
    path: "/ja/join",
    meta: joinG6hJzd4qDNqMrWK1V0hOmrgSXueSQHqN__vOusqasQEMeta || {},
    component: () => import("/app/pages/join.vue")
  },
  {
    name: "join___en",
    path: "/en/join",
    meta: joinG6hJzd4qDNqMrWK1V0hOmrgSXueSQHqN__vOusqasQEMeta || {},
    component: () => import("/app/pages/join.vue")
  },
  {
    name: newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta?.name,
    path: "/ko/news",
    component: () => import("/app/pages/news.vue"),
    children: [
  {
    name: "news-id___ko",
    path: ":id()",
    meta: _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta || {},
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news___ko",
    path: "",
    component: () => import("/app/pages/news/index.vue")
  }
]
  },
  {
    name: newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta?.name,
    path: "/ja/news",
    component: () => import("/app/pages/news.vue"),
    children: [
  {
    name: "news-id___ja",
    path: ":id()",
    meta: _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta || {},
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news___ja",
    path: "",
    component: () => import("/app/pages/news/index.vue")
  }
]
  },
  {
    name: newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta?.name,
    path: "/en/news",
    component: () => import("/app/pages/news.vue"),
    children: [
  {
    name: "news-id___en",
    path: ":id()",
    meta: _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta || {},
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news___en",
    path: "",
    component: () => import("/app/pages/news/index.vue")
  }
]
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "legal___ko",
    path: "/ko/legal",
    meta: legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta || {},
    redirect: legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta?.redirect,
    component: () => import("/app/pages/legal.vue"),
    children: [
  {
    name: "legal-type___ko",
    path: ":type()",
    meta: _91type_93QO15Mqi334KgG8myVtby0kSOoX5XbkxNL4nKBTyaQgcMeta || {},
    component: () => import("/app/pages/legal/[type].vue")
  }
]
  },
  {
    name: "legal___ja",
    path: "/ja/legal",
    meta: legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta || {},
    redirect: legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta?.redirect,
    component: () => import("/app/pages/legal.vue"),
    children: [
  {
    name: "legal-type___ja",
    path: ":type()",
    meta: _91type_93QO15Mqi334KgG8myVtby0kSOoX5XbkxNL4nKBTyaQgcMeta || {},
    component: () => import("/app/pages/legal/[type].vue")
  }
]
  },
  {
    name: "legal___en",
    path: "/en/legal",
    meta: legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta || {},
    redirect: legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta?.redirect,
    component: () => import("/app/pages/legal.vue"),
    children: [
  {
    name: "legal-type___en",
    path: ":type()",
    meta: _91type_93QO15Mqi334KgG8myVtby0kSOoX5XbkxNL4nKBTyaQgcMeta || {},
    component: () => import("/app/pages/legal/[type].vue")
  }
]
  },
  {
    name: "login___ko",
    path: "/ko/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "terms___ko",
    path: "/ko/terms",
    meta: terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta || {},
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___ja",
    path: "/ja/terms",
    meta: terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta || {},
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    meta: terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta || {},
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: noticeMikbeDwzJDB0arjP_ptdRwGjLQ3KbX4SdMjgfsSsIIUMeta?.name,
    path: "/ko/notice",
    component: () => import("/app/pages/notice.vue"),
    children: [
  {
    name: "notice-id___ko",
    path: ":id()",
    meta: _91id_9382KIwZ8q0OETkLNvcWcyEmEGEADky7LccPZr2Hn_E6cMeta || {},
    component: () => import("/app/pages/notice/[id].vue")
  },
  {
    name: "notice___ko",
    path: "",
    component: () => import("/app/pages/notice/index.vue")
  }
]
  },
  {
    name: noticeMikbeDwzJDB0arjP_ptdRwGjLQ3KbX4SdMjgfsSsIIUMeta?.name,
    path: "/ja/notice",
    component: () => import("/app/pages/notice.vue"),
    children: [
  {
    name: "notice-id___ja",
    path: ":id()",
    meta: _91id_9382KIwZ8q0OETkLNvcWcyEmEGEADky7LccPZr2Hn_E6cMeta || {},
    component: () => import("/app/pages/notice/[id].vue")
  },
  {
    name: "notice___ja",
    path: "",
    component: () => import("/app/pages/notice/index.vue")
  }
]
  },
  {
    name: noticeMikbeDwzJDB0arjP_ptdRwGjLQ3KbX4SdMjgfsSsIIUMeta?.name,
    path: "/en/notice",
    component: () => import("/app/pages/notice.vue"),
    children: [
  {
    name: "notice-id___en",
    path: ":id()",
    meta: _91id_9382KIwZ8q0OETkLNvcWcyEmEGEADky7LccPZr2Hn_E6cMeta || {},
    component: () => import("/app/pages/notice/[id].vue")
  },
  {
    name: "notice___en",
    path: "",
    component: () => import("/app/pages/notice/index.vue")
  }
]
  },
  {
    name: "download___ko",
    path: "/ko/download",
    component: () => import("/app/pages/download.vue")
  },
  {
    name: "download___ja",
    path: "/ja/download",
    component: () => import("/app/pages/download.vue")
  },
  {
    name: "download___en",
    path: "/en/download",
    component: () => import("/app/pages/download.vue")
  },
  {
    name: "nickname___ko",
    path: "/ko/nickname",
    meta: nicknameRbz_tKLZUCOffqmOAA81CGroho7pmuMgB6c0gMBne0oMeta || {},
    component: () => import("/app/pages/nickname.vue")
  },
  {
    name: "nickname___ja",
    path: "/ja/nickname",
    meta: nicknameRbz_tKLZUCOffqmOAA81CGroho7pmuMgB6c0gMBne0oMeta || {},
    component: () => import("/app/pages/nickname.vue")
  },
  {
    name: "nickname___en",
    path: "/en/nickname",
    meta: nicknameRbz_tKLZUCOffqmOAA81CGroho7pmuMgB6c0gMBne0oMeta || {},
    component: () => import("/app/pages/nickname.vue")
  },
  {
    name: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta?.name,
    path: "/ko/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue"),
    children: [
  {
    name: "settings-email___ko",
    path: "email",
    component: () => import("/app/pages/settings/email.vue")
  },
  {
    name: "settings___ko",
    path: "",
    meta: indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta || {},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: contactOVmD7bBKr0Jfiwkf1udIRL_PMnpc6b7Oi1uPKkarWk0Meta?.name,
    path: "contact",
    meta: contactOVmD7bBKr0Jfiwkf1udIRL_PMnpc6b7Oi1uPKkarWk0Meta || {},
    component: () => import("/app/pages/settings/contact.vue"),
    children: [
  {
    name: "settings-contact___ko",
    path: "",
    component: () => import("/app/pages/settings/contact/index.vue")
  },
  {
    name: "settings-contact-write___ko",
    path: "write",
    meta: write1hsMD4Q3_1bbR_EccBE4m8_HDVnwA_xFkhXF_45E8XEmUMeta || {},
    component: () => import("/app/pages/settings/contact/write.vue")
  },
  {
    name: "settings-contact-detail___ko",
    path: "detail",
    meta: detail2tntkz31j9m7I9TNts2W_hzhFaP1FF7nvOQBQilxcqEMeta || {},
    component: () => import("/app/pages/settings/contact/detail.vue")
  }
]
  },
  {
    name: "settings-nickname___ko",
    path: "nickname",
    meta: nicknameMVNfXDTU9WkJC4zViqxwQb6CuXDZB8QvWA_wIidcQtsMeta || {},
    component: () => import("/app/pages/settings/nickname.vue")
  },
  {
    name: "settings-password___ko",
    path: "password",
    component: () => import("/app/pages/settings/password.vue")
  },
  {
    name: "settings-delete-account___ko",
    path: "delete-account",
    component: () => import("/app/pages/settings/delete-account.vue")
  }
]
  },
  {
    name: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta?.name,
    path: "/ja/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue"),
    children: [
  {
    name: "settings-email___ja",
    path: "email",
    component: () => import("/app/pages/settings/email.vue")
  },
  {
    name: "settings___ja",
    path: "",
    meta: indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta || {},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: contactOVmD7bBKr0Jfiwkf1udIRL_PMnpc6b7Oi1uPKkarWk0Meta?.name,
    path: "contact",
    meta: contactOVmD7bBKr0Jfiwkf1udIRL_PMnpc6b7Oi1uPKkarWk0Meta || {},
    component: () => import("/app/pages/settings/contact.vue"),
    children: [
  {
    name: "settings-contact___ja",
    path: "",
    component: () => import("/app/pages/settings/contact/index.vue")
  },
  {
    name: "settings-contact-write___ja",
    path: "write",
    meta: write1hsMD4Q3_1bbR_EccBE4m8_HDVnwA_xFkhXF_45E8XEmUMeta || {},
    component: () => import("/app/pages/settings/contact/write.vue")
  },
  {
    name: "settings-contact-detail___ja",
    path: "detail",
    meta: detail2tntkz31j9m7I9TNts2W_hzhFaP1FF7nvOQBQilxcqEMeta || {},
    component: () => import("/app/pages/settings/contact/detail.vue")
  }
]
  },
  {
    name: "settings-nickname___ja",
    path: "nickname",
    meta: nicknameMVNfXDTU9WkJC4zViqxwQb6CuXDZB8QvWA_wIidcQtsMeta || {},
    component: () => import("/app/pages/settings/nickname.vue")
  },
  {
    name: "settings-password___ja",
    path: "password",
    component: () => import("/app/pages/settings/password.vue")
  },
  {
    name: "settings-delete-account___ja",
    path: "delete-account",
    component: () => import("/app/pages/settings/delete-account.vue")
  }
]
  },
  {
    name: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta?.name,
    path: "/en/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue"),
    children: [
  {
    name: "settings-email___en",
    path: "email",
    component: () => import("/app/pages/settings/email.vue")
  },
  {
    name: "settings___en",
    path: "",
    meta: indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta || {},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: contactOVmD7bBKr0Jfiwkf1udIRL_PMnpc6b7Oi1uPKkarWk0Meta?.name,
    path: "contact",
    meta: contactOVmD7bBKr0Jfiwkf1udIRL_PMnpc6b7Oi1uPKkarWk0Meta || {},
    component: () => import("/app/pages/settings/contact.vue"),
    children: [
  {
    name: "settings-contact___en",
    path: "",
    component: () => import("/app/pages/settings/contact/index.vue")
  },
  {
    name: "settings-contact-write___en",
    path: "write",
    meta: write1hsMD4Q3_1bbR_EccBE4m8_HDVnwA_xFkhXF_45E8XEmUMeta || {},
    component: () => import("/app/pages/settings/contact/write.vue")
  },
  {
    name: "settings-contact-detail___en",
    path: "detail",
    meta: detail2tntkz31j9m7I9TNts2W_hzhFaP1FF7nvOQBQilxcqEMeta || {},
    component: () => import("/app/pages/settings/contact/detail.vue")
  }
]
  },
  {
    name: "settings-nickname___en",
    path: "nickname",
    meta: nicknameMVNfXDTU9WkJC4zViqxwQb6CuXDZB8QvWA_wIidcQtsMeta || {},
    component: () => import("/app/pages/settings/nickname.vue")
  },
  {
    name: "settings-password___en",
    path: "password",
    component: () => import("/app/pages/settings/password.vue")
  },
  {
    name: "settings-delete-account___en",
    path: "delete-account",
    component: () => import("/app/pages/settings/delete-account.vue")
  }
]
  },
  {
    name: "textbook___ko",
    path: "/ko/textbook",
    meta: textbookSbwXsTtI6w70b7asKiFzHZTesDPELtDTVRFdMmzaaLYMeta || {},
    component: () => import("/app/pages/textbook.vue")
  },
  {
    name: "textbook___ja",
    path: "/ja/textbook",
    meta: textbookSbwXsTtI6w70b7asKiFzHZTesDPELtDTVRFdMmzaaLYMeta || {},
    component: () => import("/app/pages/textbook.vue")
  },
  {
    name: "textbook___en",
    path: "/en/textbook",
    meta: textbookSbwXsTtI6w70b7asKiFzHZTesDPELtDTVRFdMmzaaLYMeta || {},
    component: () => import("/app/pages/textbook.vue")
  },
  {
    name: "introduce___ko",
    path: "/ko/introduce",
    component: () => import("/app/pages/introduce.vue")
  },
  {
    name: "introduce___ja",
    path: "/ja/introduce",
    component: () => import("/app/pages/introduce.vue")
  },
  {
    name: "introduce___en",
    path: "/en/introduce",
    component: () => import("/app/pages/introduce.vue")
  },
  {
    name: "maintenance___ko",
    path: "/ko/maintenance",
    component: () => import("/app/pages/maintenance.vue")
  },
  {
    name: "maintenance___ja",
    path: "/ja/maintenance",
    component: () => import("/app/pages/maintenance.vue")
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance",
    component: () => import("/app/pages/maintenance.vue")
  },
  {
    name: "web-play-lite___ko",
    path: "/ko/web-play/lite",
    meta: litefEUBSsYGM_45B3JK8Blumr0mx8_45HeGaNLD1OTaqPcn2ikMeta || {},
    component: () => import("/app/pages/web-play/lite.vue")
  },
  {
    name: "web-play-lite___ja",
    path: "/ja/web-play/lite",
    meta: litefEUBSsYGM_45B3JK8Blumr0mx8_45HeGaNLD1OTaqPcn2ikMeta || {},
    component: () => import("/app/pages/web-play/lite.vue")
  },
  {
    name: "web-play-lite___en",
    path: "/en/web-play/lite",
    meta: litefEUBSsYGM_45B3JK8Blumr0mx8_45HeGaNLD1OTaqPcn2ikMeta || {},
    component: () => import("/app/pages/web-play/lite.vue")
  },
  {
    name: "web-play___ko",
    path: "/ko/web-play",
    meta: indexpQoNuxtsxBLDWwAR4tiJpvJp9EwPQkiGtEK5lm4sIloMeta || {},
    component: () => import("/app/pages/web-play/index.vue")
  },
  {
    name: "web-play___ja",
    path: "/ja/web-play",
    meta: indexpQoNuxtsxBLDWwAR4tiJpvJp9EwPQkiGtEK5lm4sIloMeta || {},
    component: () => import("/app/pages/web-play/index.vue")
  },
  {
    name: "web-play___en",
    path: "/en/web-play",
    meta: indexpQoNuxtsxBLDWwAR4tiJpvJp9EwPQkiGtEK5lm4sIloMeta || {},
    component: () => import("/app/pages/web-play/index.vue")
  },
  {
    name: "education-resources___ko",
    path: "/ko/education-resources",
    meta: education_45resourcesQ0Q3AEC7CJ_45ZAzKFMxjffmy39nZdxOD1Nq6aGgFoqZEMeta || {},
    component: () => import("/app/pages/education-resources.vue")
  },
  {
    name: "education-resources___ja",
    path: "/ja/education-resources",
    meta: education_45resourcesQ0Q3AEC7CJ_45ZAzKFMxjffmy39nZdxOD1Nq6aGgFoqZEMeta || {},
    component: () => import("/app/pages/education-resources.vue")
  },
  {
    name: "education-resources___en",
    path: "/en/education-resources",
    meta: education_45resourcesQ0Q3AEC7CJ_45ZAzKFMxjffmy39nZdxOD1Nq6aGgFoqZEMeta || {},
    component: () => import("/app/pages/education-resources.vue")
  }
]